import { Chip } from '@assembly-js/design-system';
import clsx from 'clsx';

import { getIconForFile } from './attachmentUtils';

interface AttachmentChipProps {
  title?: string;
  mimeType?: string;
  onClose?: () => void;
  onClick?: () => void;
  className?: string;
}

export const AttachmentChip = ({
  title,
  mimeType,
  onClose,
  onClick,
  className,
}: AttachmentChipProps) => {
  const getLabel = () => {
    if (title) return title;
    return 'Unsupported attachment';
  };

  const icon = getIconForFile(title, mimeType);

  return (
    <div className="m-1">
      <Chip
        variant="outlined"
        size="lg"
        prefixIcon={icon}
        label={getLabel()}
        onClose={onClose}
        onClick={onClick}
        className={clsx('bg-white', className)}
      />
    </div>
  );
};
